import type { StyleableProps } from '~/types';
import type { OAISchema } from '~/types/openapi';

import CouponDiscountedPrice from './CouponDiscountedPrice';
import { LuckyDiscountedPrice } from './LuckyDiscountedPrice';
import MembershipDiscountedPrice from './MembershipDiscountedPrice';

const ProductPrice = (
  data: OAISchema['MarketSelectProductResponseV2'] & {
    reverse?: boolean;
    wFull?: boolean;
    is3x2?: boolean;
  } & StyleableProps,
) => {
  const { priceBadge } = data;

  if (priceBadge === 'MEMBERSHIP_WEEK') {
    return <MembershipDiscountedPrice {...data} />;
  }

  if (priceBadge === 'LUCKY_BONUS_PACK') {
    return <LuckyDiscountedPrice {...data} />;
  }

  return <CouponDiscountedPrice {...data} />;
};

export default ProductPrice;
